import { dispatchCustomEvent, EventName } from "@/hooks/use-custom-event"

export function postLoginRedirect(url: string | URL) {
  dispatchCustomEvent<{ url: string | URL }>(EventName.PostLoginRedirect, {
    url,
  })
}
